/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import "../../../symbols.js";
import { format as A } from "../../../renderers/support/numberUtils.js";
import { formatAnyDate as t } from "../../../smartMapping/support/utils.js";
import l from "../../../symbols/SimpleLineSymbol.js";
const i = "<",
  a = ">";
function r(l, r, s, o) {
  let n = "";
  0 === r ? n = `${i} ` : r === s && (n = `${a} `);
  return n + (o ? t(l, o) : A(l));
}
const s = ["data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAAAAAAAAAHqZRakAAAANUlEQVQ4jWPMy8v7z0BFwMLAwMAwcdIkqhiWn5fHwEQVk5DAqIGjBo4aOGrgqIEQwEjtKgAATl0Hu6JrzFUAAAAASUVORK5CYII=", "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAAAAAAAAAHqZRakAAAANUlEQVQ4jWPMy8v7z0BFwMLAwMAwaeIkqhiWl5/HwEQVk5DAqIGjBo4aOGrgqIEQwEjtKgAATl0Hu6sKxboAAAAASUVORK5CYII=", "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAAAAAAAAAHqZRakAAAANUlEQVQ4jWPMy8v7z0BFwMLAwMAwadJEqhiWl5fPwEQVk5DAqIGjBo4aOGrgqIEQwEjtKgAATl0Hu75+IUcAAAAASUVORK5CYII="];
async function o(A) {
  if (!("visualVariables" in A) || !A.visualVariables) return null;
  const t = A.visualVariables.find(A => "color" === A.type);
  if (!t) return null;
  let l = null,
    i = null;
  if (t.stops) {
    if (1 === t.stops.length) return t.stops[0].color;
    l = t.stops[0].value, i = t.stops[t.stops.length - 1].value;
  }
  const a = null != l && null != i ? l + (i - l) / 2 : 0,
    {
      getColor: r
    } = await import("../../../renderers/visualVariables/support/visualVariableUtils.js");
  return r(t, a) ?? null;
}
async function n(A, t) {
  const i = A.trailCap,
    a = A.trailWidth || 1,
    r = t || (await o(A)) || A.color;
  return new l({
    cap: i,
    color: r,
    width: a
  });
}
function e(A) {
  return null != A && "object" == typeof A && "min" in A && "max" in A;
}
export { r as createStopLabel, o as getMedianColor, n as getSymbolForFlowRenderer, e as isRasterBandStatistics, s as rgbImgSource, a as specialCharsGreaterThan, i as specialCharsLessThan };